module.exports = __webpack_public_path__ + "static/media/cover-donation-type.1073c9da.png";